import { render, staticRenderFns } from "./CardCargo.vue?vue&type=template&id=07aa99f0&scoped=true"
import script from "./CardCargo.vue?vue&type=script&lang=js"
export * from "./CardCargo.vue?vue&type=script&lang=js"
import style0 from "./CardCargo.vue?vue&type=style&index=0&id=07aa99f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aa99f0",
  null
  
)

export default component.exports